import { SubscribedStatus } from "../../../pages/Gym/Members/types";
import { DataProviderKey, IGetListParams } from "../../../types/reactAdmin.types";
import { AppResource } from "../../../types/resource.types";
import { getFinalList } from "../../../utils/collectionQuery";
import { firestore } from "../../firebase";

const gymMembersResource = {
  [AppResource.subscribedGyms]: {
    [DataProviderKey.getList]: async (params: IGetListParams) => {
      return getFinalList(
        {
          ...params,
          limit: params.pagination.perPage,
          filter: {
            gymRef: firestore.doc(params.user.ref),
          },
        },
        firestore
          .collectionGroup(AppResource.subscribedGyms)
          .where("status", "in", [SubscribedStatus.active, SubscribedStatus.expired, SubscribedStatus.canceled])
      );
    },
  },
};

export default gymMembersResource;
